import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import page1_section1 from "../../../assets/images/AboutVedaz/page1_section1.jpg";
import page1_section2 from "../../../assets/images/AboutVedaz/page1_section2.jpg";
import page1_section3 from "../../../assets/images/AboutVedaz/page1_section3.mp4";
import page1_section5 from "../../../assets/images/AboutVedaz/page1_section5.jpg";
import classes from "../AboutVedaz.styles";

interface Props {
  chapterIndex: number;
}

const WhyVedazLove = ({ chapterIndex }: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      {/* ── Section 1: Frosted glass card over background image ───── */}
      <Box sx={classes.bgSection}>
        <Box component="img" src={page1_section1} alt="" sx={classes.bgSectionMedia} />
        <Box sx={classes.bgSectionOverlay} />
        {/* Gradient-text chapter watermark visible through dot-grid */}
        <Typography sx={classes.bgSectionChapterMark}>01</Typography>
        <Box sx={classes.bgSectionContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_why_s1_heading")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "380px", mb: 0 }}>
            {t("about_why_s1_body")}
          </Typography>
        </Box>
      </Box>

      {/* ── Section 2: Side-by-side — text left, bracketed image right */}
      <Box sx={classes.sideRow}>
        {/* Ghost chapter watermark behind the text */}
        <Typography sx={classes.sideChapterWatermark}>02</Typography>
        <Box sx={classes.sideContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_why_s2_heading")}
          </Typography>
          <Typography sx={classes.bodyText}>{t("about_why_s2_body1")}</Typography>
          <Typography sx={classes.bodyText}>{t("about_why_s2_body2")}</Typography>
          <Box sx={classes.quoteBlock}>
            <Typography sx={classes.quoteText}>
              {t("about_why_s2_quote")}
            </Typography>
          </Box>
        </Box>
        <Box sx={classes.sideImage}>
          <img src={page1_section2} alt={t("about_why_s2_heading")} />
        </Box>
      </Box>

      {/* ── Section 3: Frosted glass card over background video ───── */}
      <Box sx={classes.bgSection}>
        <Box
          component="video"
          src={page1_section3}
          autoPlay
          muted
          loop
          playsInline
          sx={classes.bgSectionMedia}
        />
        <Box sx={classes.bgSectionOverlay} />
        <Typography sx={classes.bgSectionChapterMark}>03</Typography>
        <Box sx={classes.bgSectionContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_why_s3_heading")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "380px" }}>
            {t("about_why_s3_body1")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "380px", mb: 0 }}>
            {t("about_why_s3_body2")}
          </Typography>
        </Box>
      </Box>

      {/* ── Section 4: Multi-spotlight plain section ──────────────── */}
      <Box sx={classes.plainSection}>
        <Typography sx={classes.sectionHeading}>
          {t("about_why_s4_heading")}
        </Typography>
        <Typography sx={classes.sectionSubheading}>
          {t("about_why_s4_subheading")}
        </Typography>
        <Typography sx={classes.bodyText}>{t("about_why_s4_body1")}</Typography>
        <Typography sx={{ ...classes.bodyText, mb: 0 }}>
          {t("about_why_s4_body2")}
        </Typography>
      </Box>

      {/* ── Section 5: Side-by-side — bracketed image left, text right */}
      <Box sx={classes.sideRowReverse}>
        {/* Ghost chapter watermark behind the text */}
        <Typography sx={classes.sideChapterWatermark}>05</Typography>
        <Box sx={classes.sideContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_why_s5_heading")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, mb: 0 }}>
            {t("about_why_s5_body")}
          </Typography>
        </Box>
        <Box sx={classes.sideImage}>
          <img src={page1_section5} alt={t("about_why_s5_heading")} />
        </Box>
      </Box>
    </Box>
  );
};

export default WhyVedazLove;
